import { render } from "./AposTiptapAnchor.vue?vue&type=template&id=71ec3b8c&scoped=true"
import script from "./AposTiptapAnchor.vue?vue&type=script&lang=js"
export * from "./AposTiptapAnchor.vue?vue&type=script&lang=js"

import "./AposTiptapAnchor.vue?vue&type=style&index=0&id=71ec3b8c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71ec3b8c"],['__file',"rich-text-widget/ui/apos/components/AposTiptapAnchor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "71ec3b8c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('71ec3b8c', __exports__)) {
    api.reload('71ec3b8c', __exports__)
  }
  
  module.hot.accept("./AposTiptapAnchor.vue?vue&type=template&id=71ec3b8c&scoped=true", () => {
    api.rerender('71ec3b8c', render)
  })

}


export default __exports__